module.exports = __webpack_public_path__ + "static/media/HCMM204.7d232c86.jpg";